import { UAParser } from 'ua-parser-js';
import { baseApi } from '@/api/rtk/baseApi';
import { runMutation } from '@/api/rtk/runEndpoint';
import '@/api/rtk/mutationsApi';

const buildRecordingLogBody = ({ type, duration, reportId, createdAt }) => {
  const parser = new UAParser();
  const parserResult = parser.getResult();
  return {
    type,
    duration: duration.toFixed(2),
    reportId,
    createdAt,
    device: parserResult.device.model
      ? `${parserResult.device.vendor} ${parserResult.device.model}`
      : 'Desktop',
    browser: `${parserResult.browser.name} ${parserResult.browser.version}`,
    os: `${parserResult.os.name} ${parserResult.os.version}`,
    userAgent: parserResult.ua,
  };
};

export const createRecordingLog = async ({ type, duration, reportId, createdAt }) => {
  try {
    const data = await runMutation(
      baseApi.endpoints.createRecordingLog,
      buildRecordingLogBody({ type, duration, reportId, createdAt })
    );
    return data?.log ?? null;
  } catch {
    return null;
  }
};
